module.exports = __webpack_public_path__ + "img/interpackmaxi-inactive.f61cdb62.svg";